const CaasStorageKeys = {
  CLIENT: 'client',
  DEVICE: 'device',
  STORAGE: 'storage',
  CONFIG: 'caas_config',
  NOTIFICATIONS: 'notifications',
  organizationsNames: 'organizationsNames',
};

export default CaasStorageKeys;
